var map = {
	"./BANKSTATEMENT.png": "03a1",
	"./CV.png": "0a8c",
	"./DRIVINGLICENSE.png": "81ce",
	"./NATIONALID.png": "532d",
	"./PASSPORT.png": "6d27",
	"./PROPERTYTAXRECEIPT.png": "fcea",
	"./UTILITYBILL.png": "a654",
	"./VERIFIEDFORM.png": "e4b2",
	"./VOTERID.png": "ed5c",
	"./plane.png": "eb93",
	"./verified.png": "522e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c3b";